import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useSTColumns, useSTRows } from '../table';
import { Filters } from './Filters';
export function FilterSection({ enableAutocomplete = true }) {
    const { allColumns, visibleColumns } = useSTColumns();
    const { rowsFilterCondition, setRowsFilterCondition } = useSTRows();
    const filtrableColumns = useMemo(() => allColumns
        .filter((column) => column.fieldName !== 'index' &&
        (visibleColumns.some((visibleCol) => visibleCol.fieldName === column.fieldName) || column.isFilterOnly))
        .sort((a, b) => {
        if (a.isFilterOnly && !b.isFilterOnly)
            return -1;
        if (!a.isFilterOnly && b.isFilterOnly)
            return 1;
        return 0;
    }), [allColumns, visibleColumns]);
    return (_jsx(Stack, { direction: "row", alignItems: "center", flexWrap: "wrap", gap: 1, children: _jsx(Filters, { conditions: rowsFilterCondition, onConditionsChange: setRowsFilterCondition, filterColumns: filtrableColumns, enableAutocomplete: enableAutocomplete }) }));
}
//# sourceMappingURL=FilterSection.js.map